// Vendor libraries
import { ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
// Utils
import { formatDateString, getDaysInMonth, getFirstDayOfMonth, isValidDate, LONG_MONTH_NAMES, } from 'Core/redesign/utils/date';
import { isValidDateForDateRange } from 'NewAngular/features/components/date-controls/single-date-picker/utils/single-date-picker-utils';
import equal from 'NewAngular/utils/equal/deep-equal';
// Services
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/dropdown-helper.service";
import * as i2 from "../../../directives/append-to-body/append-to-body.directive";
import * as i3 from "@angular/common";
import * as i4 from "../../../directives/disabled/disabled.directive";
import * as i5 from "@angular/forms";
import * as i6 from "../../dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i7 from "NewAngular/features/components/date-controls/single-date-picker/pipes/is-date-item-selected.pipe";
import * as i8 from "NewAngular/features/components/date-controls/single-date-picker/pipes/is-date-item-within-date-range.pipe";
import * as i9 from "NewAngular/features/components/date-controls/single-date-picker/pipes/is-valid-date-for-date-range.pipe";
const _c0 = ["singleDatePicker"];
const _c1 = (a0, a1) => ({ "pointer-events": a0, "border-color": a1 });
const _c2 = a0 => ({ show: a0 });
const _c3 = () => ({ button: "btn btn-secondary btn-block style-underline", dropdownMenu: "dropdown-menu-scrollable-xl" });
const _c4 = (a0, a1) => ({ "highlight-range": a0, "highlight-yc-blue": a1 });
const _c5 = a0 => ({ "datepicker-week-end": a0 });
const _c6 = (a0, a1, a2, a3, a4, a5) => [a0, a1, a2, a3, a4, a5];
const _c7 = a0 => ({ "state-highlight": a0 });
function SingleDatePickerComponent_td_36_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵlistener("click", function SingleDatePickerComponent_td_36_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const dateItem_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.dateSelected(dateItem_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dateItem_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r3, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r3, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r3, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r3.day);
} }
function SingleDatePickerComponent_td_36_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
} if (rf & 2) {
    const dateItem_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r3, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r3, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r3, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r3.day);
} }
function SingleDatePickerComponent_td_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 24);
    i0.ɵɵpipe(1, "isDateItemWithinDateRange");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtemplate(5, SingleDatePickerComponent_td_36_a_5_Template, 4, 13, "a", 25);
    i0.ɵɵpipe(6, "isValidDateForDateRange");
    i0.ɵɵtemplate(7, SingleDatePickerComponent_td_36_ng_template_7_Template, 4, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dateItem_r3 = ctx.$implicit;
    const i_r5 = ctx.index;
    const disabled_date_r6 = i0.ɵɵreference(8);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c4, i0.ɵɵpipeBind3(1, 4, dateItem_r3, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate), i0.ɵɵpipeBind2(2, 8, dateItem_r3, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 11, dateItem_r3, ctx_r3.selectedDateRange.endDate)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c5, i_r5 === 0 || i_r5 == 6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dateItem_r3.month === ctx_r3.selectedMonth && i0.ɵɵpipeBindV(6, 14, i0.ɵɵpureFunction6(26, _c6, dateItem_r3, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate, ctx_r3.isStartOfRange, ctx_r3.startDate, ctx_r3.endDate)))("ngIfElse", disabled_date_r6);
} }
function SingleDatePickerComponent_tr_38_td_1_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵlistener("click", function SingleDatePickerComponent_tr_38_td_1_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r7); const dateItem_r8 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.dateSelected(dateItem_r8)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dateItem_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r8, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r8, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r8, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r8.day);
} }
function SingleDatePickerComponent_tr_38_td_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
} if (rf & 2) {
    const dateItem_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", dateItem_r8.day);
} }
function SingleDatePickerComponent_tr_38_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 24);
    i0.ɵɵpipe(1, "isDateItemWithinDateRange");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtemplate(5, SingleDatePickerComponent_tr_38_td_1_a_5_Template, 4, 13, "a", 25);
    i0.ɵɵpipe(6, "isValidDateForDateRange");
    i0.ɵɵtemplate(7, SingleDatePickerComponent_tr_38_td_1_ng_template_7_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dateItem_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const disabled_date_r10 = i0.ɵɵreference(8);
    const indexRange_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c4, i0.ɵɵpipeBind3(1, 4, dateItem_r8, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate), i0.ɵɵpipeBind2(2, 8, dateItem_r8, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 11, dateItem_r8, ctx_r3.selectedDateRange.endDate)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c5, i_r9 === indexRange_r11.startIndex || i_r9 == indexRange_r11.endIndex - 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBindV(6, 14, i0.ɵɵpureFunction6(26, _c6, dateItem_r8, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate, ctx_r3.isStartOfRange, ctx_r3.startDate, ctx_r3.endDate)))("ngIfElse", disabled_date_r10);
} }
function SingleDatePickerComponent_tr_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, SingleDatePickerComponent_tr_38_td_1_Template, 9, 33, "td", 21);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const indexRange_r11 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 1, ctx_r3.dateItems, indexRange_r11.startIndex, indexRange_r11.endIndex));
} }
function SingleDatePickerComponent_td_40_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵlistener("click", function SingleDatePickerComponent_td_40_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r12); const dateItem_r13 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.dateSelected(dateItem_r13)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dateItem_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r13, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r13, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r13, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r13.day);
} }
function SingleDatePickerComponent_td_40_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
} if (rf & 2) {
    const dateItem_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r13, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r13, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r13, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r13.day);
} }
function SingleDatePickerComponent_td_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 24);
    i0.ɵɵpipe(1, "isDateItemWithinDateRange");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtemplate(5, SingleDatePickerComponent_td_40_a_5_Template, 4, 13, "a", 25);
    i0.ɵɵpipe(6, "isValidDateForDateRange");
    i0.ɵɵtemplate(7, SingleDatePickerComponent_td_40_ng_template_7_Template, 4, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dateItem_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const disabled_date_r15 = i0.ɵɵreference(8);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c4, i0.ɵɵpipeBind3(1, 4, dateItem_r13, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate), i0.ɵɵpipeBind2(2, 8, dateItem_r13, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 11, dateItem_r13, ctx_r3.selectedDateRange.endDate)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c5, i_r14 === 28 || i_r14 == 34));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dateItem_r13.month === ctx_r3.selectedMonth && i0.ɵɵpipeBindV(6, 14, i0.ɵɵpureFunction6(26, _c6, dateItem_r13, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate, ctx_r3.isStartOfRange, ctx_r3.startDate, ctx_r3.endDate)))("ngIfElse", disabled_date_r15);
} }
function SingleDatePickerComponent_tr_42_td_1_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵlistener("click", function SingleDatePickerComponent_tr_42_td_1_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r16); const dateItem_r17 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.dateSelected(dateItem_r17)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dateItem_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r17, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r17, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r17, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r17.day);
} }
function SingleDatePickerComponent_tr_42_td_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
    i0.ɵɵpipe(1, "isDateItemSelected");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
} if (rf & 2) {
    const dateItem_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, i0.ɵɵpipeBind2(1, 2, dateItem_r17, ctx_r3.selectedDate) || i0.ɵɵpipeBind2(2, 5, dateItem_r17, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 8, dateItem_r17, ctx_r3.selectedDateRange.endDate)))("textContent", dateItem_r17.day);
} }
function SingleDatePickerComponent_tr_42_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 24);
    i0.ɵɵpipe(1, "isDateItemWithinDateRange");
    i0.ɵɵpipe(2, "isDateItemSelected");
    i0.ɵɵpipe(3, "isDateItemSelected");
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtemplate(5, SingleDatePickerComponent_tr_42_td_1_a_5_Template, 4, 13, "a", 25);
    i0.ɵɵpipe(6, "isValidDateForDateRange");
    i0.ɵɵtemplate(7, SingleDatePickerComponent_tr_42_td_1_ng_template_7_Template, 4, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dateItem_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    const disabled_date_r19 = i0.ɵɵreference(8);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c4, i0.ɵɵpipeBind3(1, 4, dateItem_r17, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate), i0.ɵɵpipeBind2(2, 8, dateItem_r17, ctx_r3.selectedDateRange.startDate) || i0.ɵɵpipeBind2(3, 11, dateItem_r17, ctx_r3.selectedDateRange.endDate)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c5, i_r18 === 35 || i_r18 == 41));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dateItem_r17.month === ctx_r3.selectedMonth && i0.ɵɵpipeBindV(6, 14, i0.ɵɵpureFunction6(26, _c6, dateItem_r17, ctx_r3.selectedDateRange.startDate, ctx_r3.selectedDateRange.endDate, ctx_r3.isStartOfRange, ctx_r3.startDate, ctx_r3.endDate)))("ngIfElse", disabled_date_r19);
} }
function SingleDatePickerComponent_tr_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, SingleDatePickerComponent_tr_42_td_1_Template, 9, 33, "td", 21);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 1, ctx_r3.dateItems, 35, 42));
} }
/**
 * SingleDatePickerComponent
 *
 * This component allows a user to select a date within the range of years provided as input. The functionality
 * of this component is based upon the old ycSingleDatePicker component that was implemented using AngularJS.
 *
 * For selectable date ranges populate either startYear and endYear or startDate or endDate.
 *
 * Input Properties:
 *  startYear: number that is the start of the range of years for which dates should be selectable, e.g. 2010
 *  endYear: number that is the end of the range of years for which dates should be selectable, e.g. 2021
 *  startDate: Date that is the start of the range for which dates should be selectable.
 *  endYear: Date that is the end of the range for which dates should be selectable.
 *  selectedDate: Date object that is the currently selected date
 *  selectedDateRange: DateRange object that determines the date range highlighting when this component is part of
 *                     a date range component
 *  isStartOfRange: boolean which specifies the role of the date picker component as part of a date range component
 *
 * Output Properties:
 *  dateChangeHandler: EventEmitter<Date | null> that emits the new date when a date is selected, or emits null
 *                     if the datepicker is cleared out
 *
 */
export class SingleDatePickerComponent {
    constructor(dropdownHelperService) {
        this.dropdownHelperService = dropdownHelperService;
        this.CURRENT_DATE = new Date();
        this.CURRENT_MONTH = this.CURRENT_DATE.getMonth();
        this.CURRENT_YEAR = this.CURRENT_DATE.getFullYear();
        // Generates the entries in the month dropdown of the date picker. The current month is selected initially.
        this.MONTH_DROPDOWN_CONFIG = {
            title: { label: '' },
            list: LONG_MONTH_NAMES.map((month, index) => {
                return {
                    label: month,
                    value: index,
                    selected: index === this.CURRENT_MONTH,
                };
            }),
        };
        // default startYear is 1890, same as the AngularJS component
        this.startYear = 1890;
        // default endYear is currentYear + 5, same as the Angular JS component
        this.endYear = this.CURRENT_YEAR + 5;
        this.selectedDate = null;
        this.selectedDateRange = { startDate: null, endDate: null };
        // Used to determine which part of a date range this date picker is
        this.isStartOfRange = true;
        this.inputDisabled = false;
        this.datePlaceholder = 'MM/DD/YYYY';
        this.blockInput = false;
        this.appendToBody = false;
        this.dateChangeHandler = new EventEmitter();
        this.dateItems = [];
        this.dateString = '';
        this.isOpen = false;
        // This is used in the template for generating the rows in the date picker table that are not first or last
        this.middleRowDateItemIndexRanges = [
            { startIndex: 7, endIndex: 14 },
            { startIndex: 14, endIndex: 21 },
            { startIndex: 21, endIndex: 28 },
        ];
        this.selectedDay = null;
        this.selectedMonth = this.CURRENT_MONTH;
        this.selectedYear = this.CURRENT_YEAR;
        this.yearDropdownConfig = {
            title: { label: '' },
            list: [],
        };
        this.dateInvalid = false;
        // Defined as arrow function so this references the component inside the function
        this.closeDatePickerOnKeyPress = () => {
            this.isOpen = false;
        };
    }
    ngOnInit() {
        // Need to reassign full object to trigger SingleSelectDropdownComponent's ngOnChanges
        this.yearDropdownConfig = {
            title: { label: '' },
            list: this.generateYearDropdownItems(),
        };
        this.dateItems = this.generateDatePickerItems(this.selectedYear, this.selectedMonth);
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.toggleDatePicker();
            }
        };
        let dropdownElement = this.el.nativeElement;
        if (!this.appendToBody)
            dropdownElement = dropdownElement.parentNode;
        this.dropdownHelperService.setCloseHandler(dropdownElement, autoCloseHandler);
    }
    ngOnChanges(changes) {
        if (changes.startDate?.currentValue && changes.endDate?.currentValue) {
            this.yearDropdownConfig = {
                title: { label: '' },
                list: this.generateYearDropdownItems(),
            };
            // Select date limits Month and Year to avoid user searching for limits
            if (this.selectedDate === null) {
                if (this.isStartOfRange) {
                    this.monthChanged(this.startDate.getMonth());
                    this.yearChanged(this.startDate.getFullYear());
                }
                else {
                    this.monthChanged(this.endDate.getMonth());
                    this.yearChanged(this.endDate.getFullYear());
                }
            }
            else {
                // Reset selected date if invalid and set Month and Year
                const validNewDate = this.selectedDate >= this.startDate && this.selectedDate <= this.endDate;
                if (!validNewDate) {
                    this.dateSelected(null);
                    if (this.isStartOfRange) {
                        this.monthChanged(this.startDate.getMonth());
                        this.yearChanged(this.startDate.getFullYear());
                    }
                    else {
                        this.monthChanged(this.endDate.getMonth());
                        this.yearChanged(this.endDate.getFullYear());
                    }
                }
            }
        }
        if (changes.selectedDate?.currentValue &&
            !equal(changes.selectedDate.currentValue, changes.selectedDate.previousValue)) {
            const newDate = changes.selectedDate?.currentValue;
            const validNewDate = this.startDate && this.endDate
                ? newDate instanceof Date && newDate >= this.startDate && newDate <= this.endDate
                : newDate instanceof Date &&
                    newDate.getFullYear() >= this.startYear &&
                    newDate.getFullYear() <= this.endYear;
            // Only select the new date if it is within the allowable range of years, otherwise clear the datepicker
            if (validNewDate) {
                this.dateSelected(this.createDatePickerItemFromDate(newDate), false);
            }
            else {
                // Emit the null date so that the parent component can update the state
                this.dateSelected(null);
            }
        }
        else if (changes.selectedDate?.currentValue === null) {
            // When an invalid date for a parent date range component is entered, clear the selected date and date string
            this.dateSelected(null, false);
        }
    }
    toggleDatePicker() {
        this.isOpen = !this.isOpen;
    }
    /**
     * Given a Date object, create a SingleDatePickerItem with the same date.
     * @param date: Date to use when creating the SingleDatePickerItem
     * @returns SingleDatePickerItem with same year, month, and day as the provided date
     */
    createDatePickerItemFromDate(date) {
        return {
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate(),
        };
    }
    /**
     * This function handles when a user is typing in the input box. If they clear the input box then
     * no date will be selected. If they enter a valid date in the format given by the placeholder string
     * 'MM/DD/YY' then the corresponding date picker item will be selected.
     * @param newDateString: the string entered into the input box
     */
    dateStringChanged(newDateString) {
        this.isOpen = true;
        if (newDateString.trim().length === 0) {
            this.dateSelected(null);
        }
        else if (isValidDate(newDateString, this.startDate?.getFullYear() || this.startYear, this.endDate?.getFullYear() || this.endYear)) {
            const newDate = new Date(newDateString);
            if (isValidDateForDateRange(newDate, this.selectedDateRange.startDate, this.selectedDateRange.endDate, this.isStartOfRange, this.startDate, this.endDate)) {
                this.dateSelected(this.createDatePickerItemFromDate(newDate));
            }
            else {
                this.dateInvalid = true;
            }
        }
        else {
            this.dateInvalid = true;
        }
    }
    /**
     * Generates the entries in the year dropdown of the date picker. The current year is selected initially.
     * @returns SingleSelectDropdownItem[] that contains a dropdown item for each year in the range of
     * years between the start year and the end year that were input to the component.
     */
    generateYearDropdownItems() {
        const numYears = this.startDate && this.endDate
            ? this.endDate.getFullYear() - this.startDate.getFullYear() + 1
            : this.endYear - this.startYear + 1;
        return Array(numYears)
            .fill(0) // Placeholder value to allow iteration as many times as there are years
            .map((element, index) => {
            const year = (this.startDate?.getFullYear() || this.startYear) + index;
            return {
                label: `${year}`,
                value: year,
                selected: this.CURRENT_YEAR === year,
            };
        });
    }
    /**
     * Given a year and month, this function generates the date picker items for that month. Each date picker item
     * represents a day, and they are used in the template to create the rows of selectable days in the
     * date picker calendar. Days in the previous month or next month are not be selectable.
     * @param yearVal: number that is the year to generate the date picker items for
     * @param monthVal: MonthNumber (e.g. 0-11) that is the month to generate the date picker items for
     * @returns SingleDatePickerItem[] that contains an item for each day in the given month plus whatever extra
     * items are needed to fill the rows in the calendar.
     */
    generateDatePickerItems(yearVal, monthVal) {
        const dateItems = [];
        const numDaysInCurrentMonth = getDaysInMonth(yearVal, monthVal);
        // firstDayOfMonth refers to the day of the week that the first day of the month
        // occurs on. Ror example, the first day in March 2018 is a Thursday, which is represented as 4
        const firstDayOfMonth = getFirstDayOfMonth(yearVal, monthVal);
        // Compute the previous month and what year that previous month is a part of
        const prevMonthAndYear = this.getPrevMonthAndYear(yearVal, monthVal);
        const numDaysInPrevMonth = getDaysInMonth(prevMonthAndYear.year, prevMonthAndYear.month);
        // handle all the disabled days from the previous month
        for (let i = 1; i <= firstDayOfMonth; i += 1) {
            const prevDay = numDaysInPrevMonth - firstDayOfMonth + i;
            const prevDate = {
                year: prevMonthAndYear.year,
                month: prevMonthAndYear.month,
                day: prevDay,
            };
            dateItems.push(prevDate);
        }
        // handle all the days in the current month
        for (let day = 1; day <= numDaysInCurrentMonth; day += 1) {
            const date = {
                year: yearVal,
                month: monthVal,
                day,
            };
            dateItems.push(date);
        }
        // We show rows of 7 dateItems on the frontend. Usually only 5 rows are needed,
        // meaning a total of 7 * 5 = 35 dateItems. There is a possibility that long months
        // with their first day happening on a Friday or Saturday need an extra row to
        // display all the days, so 6 rows will be displayed on the frontend in that case.
        const totalDaysNeeded = dateItems.length > 35 ? 42 : 35;
        // Compute the next month and what year that next month is a part of
        const nextMonthAndYear = this.getNextMonthAndYear(yearVal, monthVal);
        // Handle all the disabled days for next month
        const numDisabledDays = totalDaysNeeded - dateItems.length;
        for (let nextMonthDay = 1; nextMonthDay <= numDisabledDays; nextMonthDay += 1) {
            const futureDate = {
                year: nextMonthAndYear.year,
                month: nextMonthAndYear.month,
                day: nextMonthDay,
            };
            dateItems.push(futureDate);
        }
        return dateItems;
    }
    /**
     * Handles when a date is selected in the date picker.
     * @param dateItem: SingleDatePickerItem that was selected
     * @param emitDate: boolean whether or not to emit the newly selected date and trigger the dateChangeHandler.
     */
    dateSelected(dateItem, emitDate = true) {
        if (dateItem) {
            this.dateInvalid = false;
            // Update selected year, month, and day
            this.selectedYear = dateItem.year;
            this.selectedMonth = dateItem.month;
            this.selectedDay = dateItem.day;
            // Regenerate datepicker items based on what is selected
            this.dateItems = this.generateDatePickerItems(this.selectedYear, this.selectedMonth);
            // Update the selected Date object
            this.selectedDate = new Date(this.selectedYear, this.selectedMonth, this.selectedDay);
            // Populate the date string based on the selected Date object
            this.dateString = formatDateString(this.selectedDate);
            // Close the datepicker on date selection
        }
        else {
            // Date was invalid or cleared out
            this.selectedDate = null;
            this.dateString = '';
        }
        // Close the date picker on selection
        this.isOpen = false;
        if (emitDate) {
            this.dateChangeHandler.emit(this.selectedDate);
        }
    }
    /**
     * Handles when a month is selected in the month dropdown of the datepicker. New date items are generated
     * based on the newly selected month.
     * @param newMonth: MonthNumber that was newly selected
     */
    monthChanged(newMonth) {
        if (newMonth !== this.selectedMonth) {
            this.selectedMonth = newMonth;
            this.dateItems = this.generateDatePickerItems(this.selectedYear, this.selectedMonth);
        }
    }
    /**
     * Handles when a year is selected in the year dropdown of the datepicker. New date items are generated
     * based on the newly selected month.
     * @param newYear: number that was newly selected
     */
    yearChanged(newYear) {
        if (newYear !== this.selectedYear) {
            this.selectedYear = newYear;
            this.dateItems = this.generateDatePickerItems(this.selectedYear, this.selectedMonth);
        }
    }
    /**
     * Handles when the arrow button to go to the next month is clicked. New date picker items are then
     * generated for the next month.
     */
    nextMonth() {
        const nextMonthAndYear = this.getNextMonthAndYear(this.selectedYear, this.selectedMonth);
        this.selectedYear = nextMonthAndYear.year;
        this.selectedMonth = nextMonthAndYear.month;
        this.dateItems = this.generateDatePickerItems(this.selectedYear, this.selectedMonth);
    }
    /**
     * Handles when the arrow button to go to the previous month is clicked. New date picker items are then
     * generated for the previous month.
     */
    prevMonth() {
        const prevMonthAndYear = this.getPrevMonthAndYear(this.selectedYear, this.selectedMonth);
        this.selectedYear = prevMonthAndYear.year;
        this.selectedMonth = prevMonthAndYear.month;
        this.dateItems = this.generateDatePickerItems(this.selectedYear, this.selectedMonth);
    }
    /**
     * Compute what month and year immediately follow a given month and year. In most cases the month
     * only needs to be incremented, but if it is the last month of the year then the next month will be 0
     * and the year is incremented.
     * @param currentYear: number that is the year of the currentMonth
     * @param currentMonth: MonthNumber to compute the next month and year for
     * @returns MonthAndYear object that contains the immediately following month and year
     */
    getNextMonthAndYear(currentYear, currentMonth) {
        if (currentMonth === 11) {
            return {
                month: 0,
                year: currentYear + 1,
            };
        }
        return {
            month: (currentMonth + 1),
            year: currentYear,
        };
    }
    /**
     * Compute what month and year immediately precede a given month and year. In most cases the month
     * only needs to be decremented, but if it is the first month of the year then the previous month will be 11
     * and the year will be decremented.
     * @param currentYear
     * @param currentMonth
     * @returns MonthAndYear object that contains the immediately preceding month and year
     */
    getPrevMonthAndYear(currentYear, currentMonth) {
        if (currentMonth === 0) {
            return {
                month: 11,
                year: currentYear - 1,
            };
        }
        return {
            month: (currentMonth - 1),
            year: currentYear,
        };
    }
}
SingleDatePickerComponent.ɵfac = function SingleDatePickerComponent_Factory(t) { return new (t || SingleDatePickerComponent)(i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
SingleDatePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleDatePickerComponent, selectors: [["ycn-single-date-picker"]], viewQuery: function SingleDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, inputs: { startYear: "startYear", endYear: "endYear", endDate: "endDate", startDate: "startDate", selectedDate: "selectedDate", selectedDateRange: "selectedDateRange", isStartOfRange: "isStartOfRange", inputDisabled: "inputDisabled", datePlaceholder: "datePlaceholder", blockInput: "blockInput", appendToBody: "appendToBody" }, outputs: { dateChangeHandler: "dateChangeHandler" }, features: [i0.ɵɵNgOnChangesFeature], decls: 43, vars: 35, consts: [["singleDatePicker", ""], ["disabled_date", ""], [1, "form-control", "dropdown-toggle", 3, "ngModelChange", "keydown.escape", "keydown.enter", "click", "disabled", "placeholder", "ngModel"], [1, "dropdown-menu", 3, "ycnAppendToBody", "ngClass"], [1, "datepicker"], [1, "datepicker-header"], ["data-handler", "prev", "data-event", "click", "title", "Prev", "ycnDisabled", "", 1, "btn", "btn-transparent", "datepicker-nav", "datepicker-nav-prev", 3, "click", "disabled"], [1, "datepicker-title"], ["data-test-id", "month-dropdown", 1, "dropdown", 3, "changeHandler", "config", "customCssClasses", "selectedValue"], ["data-test-id", "year-dropdown", 1, "dropdown", 3, "changeHandler", "config", "customCssClasses", "selectedValue", "scrollToSelected"], ["data-handler", "next", "data-event", "click", "title", "Next", "ycnDisabled", "", 1, "btn", "btn-transparent", "datepicker-nav", "datepicker-nav-next", 3, "click", "disabled"], [1, "datepicker-calendar"], ["scope", "col", 1, "datepicker-week-end"], ["title", "Sunday"], ["scope", "col"], ["title", "Monday"], ["title", "Tuesday"], ["title", "Wednesday"], ["title", "Thursday"], ["title", "Friday"], ["title", "Saturday"], [3, "ngClass", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngClass"], ["class", "state-default", "href", "javascript:void(0)", 3, "ngClass", "textContent", "click", 4, "ngIf", "ngIfElse"], ["href", "javascript:void(0)", 1, "state-default", 3, "click", "ngClass", "textContent"], [1, "datepicker-other-month", "datepicker-unselectable", "state-disabled", 3, "ngClass", "textContent"], [1, "datepicker-other-month", "datepicker-unselectable", "state-disabled", 3, "textContent"]], template: function SingleDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "input", 2);
        i0.ɵɵlistener("ngModelChange", function SingleDatePickerComponent_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateStringChanged($event)); })("keydown.escape", function SingleDatePickerComponent_Template_input_keydown_escape_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeDatePickerOnKeyPress()); })("keydown.enter", function SingleDatePickerComponent_Template_input_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeDatePickerOnKeyPress()); })("click", function SingleDatePickerComponent_Template_input_click_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleDatePicker()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 3, 0)(3, "div", 4)(4, "div", 5)(5, "a", 6);
        i0.ɵɵlistener("click", function SingleDatePickerComponent_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.prevMonth()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 7)(7, "ycn-single-select-dropdown", 8);
        i0.ɵɵlistener("changeHandler", function SingleDatePickerComponent_Template_ycn_single_select_dropdown_changeHandler_7_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.monthChanged($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-single-select-dropdown", 9);
        i0.ɵɵlistener("changeHandler", function SingleDatePickerComponent_Template_ycn_single_select_dropdown_changeHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.yearChanged($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "a", 10);
        i0.ɵɵlistener("click", function SingleDatePickerComponent_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.nextMonth()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "table", 11)(11, "thead")(12, "tr")(13, "th", 12)(14, "span", 13);
        i0.ɵɵtext(15, "Su");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "th", 14)(17, "span", 15);
        i0.ɵɵtext(18, "Mo");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "th", 14)(20, "span", 16);
        i0.ɵɵtext(21, "Tu");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "th", 14)(23, "span", 17);
        i0.ɵɵtext(24, "We");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(25, "th", 14)(26, "span", 18);
        i0.ɵɵtext(27, "Th");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(28, "th", 14)(29, "span", 19);
        i0.ɵɵtext(30, "Fr");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(31, "th", 12)(32, "span", 20);
        i0.ɵɵtext(33, "Sa");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(34, "tbody")(35, "tr");
        i0.ɵɵtemplate(36, SingleDatePickerComponent_td_36_Template, 9, 33, "td", 21);
        i0.ɵɵpipe(37, "slice");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(38, SingleDatePickerComponent_tr_38_Template, 3, 5, "tr", 22);
        i0.ɵɵelementStart(39, "tr");
        i0.ɵɵtemplate(40, SingleDatePickerComponent_td_40_Template, 9, 33, "td", 21);
        i0.ɵɵpipe(41, "slice");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(42, SingleDatePickerComponent_tr_42_Template, 3, 5, "tr", 23);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction2(28, _c1, ctx.blockInput ? "none" : "auto", ctx.dateInvalid ? "red" : ""));
        i0.ɵɵproperty("disabled", ctx.inputDisabled)("placeholder", ctx.datePlaceholder)("ngModel", ctx.dateString);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ycnAppendToBody", ctx.appendToBody)("ngClass", i0.ɵɵpureFunction1(31, _c2, ctx.isOpen));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.selectedMonth === 0 && ctx.selectedYear === ((ctx.startDate == null ? null : ctx.startDate.getFullYear()) || ctx.startYear));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("config", ctx.MONTH_DROPDOWN_CONFIG)("customCssClasses", i0.ɵɵpureFunction0(33, _c3))("selectedValue", ctx.selectedMonth);
        i0.ɵɵadvance();
        i0.ɵɵproperty("config", ctx.yearDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(34, _c3))("selectedValue", ctx.selectedYear)("scrollToSelected", true);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx.selectedMonth === 11 && ctx.selectedYear === ((ctx.endDate == null ? null : ctx.endDate.getFullYear()) || ctx.endYear));
        i0.ɵɵadvance(27);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(37, 20, ctx.dateItems, 0, 7));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.middleRowDateItemIndexRanges);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(41, 24, ctx.dateItems, 28, 35));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dateItems.length === 42);
    } }, dependencies: [i2.AppendToBodyDirective, i3.NgClass, i3.NgForOf, i3.NgIf, i4.DisabledDirective, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i6.SingleSelectDropdownComponent, i3.SlicePipe, i7.isDateItemSelectedPipe, i8.isDateItemWithinDateRangePipe, i9.isValidDateForDateRangePipe], encapsulation: 2, changeDetection: 0 });
